import { Static, Object, String, Union, Literal, Number, Optional } from '@sinclair/typebox';

import { TripType } from '../../sas-domain/common';

export type AwardFlightOffersRequestQuery = Static<typeof AwardFlightOffersRequestQuery>;
export const AwardFlightOffersRequestQuery = Object({
  origin: String({
    examples: ['ARN'],
    description: 'Origin airport code',
    pattern: '[A-Z]{3}',
  }),
  destination: String({
    examples: ['CPH'],
    description: 'Destination airport code',
    pattern: '[A-Z]{3}',
  }),
  outboundDate: String({
    examples: ['2024-08-20'],
    description: 'Date of departure',
    pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
  }),
  inboundDate: Optional(
    String({
      examples: ['2024-08-30'],
      description: 'Date of return trip (required for round-trip)',
      pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
    })
  ),
  tripType: Union([Literal(TripType.ONE_WAY), Literal(TripType.ROUND_TRIP)], {
    description: 'Specifies if it is a round trip or a one way trip',
    examples: [TripType.ONE_WAY, TripType.ROUND_TRIP],
  }),
  adults: Number({
    maximum: 9,
    description: 'Number of adult travelers',
    examples: [2],
  }),
  children: Optional(
    Number({
      description: 'Number of children',
      examples: [1],
    })
  ),
  infants: Optional(
    Number({
      description: 'Number of infants (must be equal or less to the number of adult travelers)',
      examples: [1],
    })
  ),
  selectedCouponCodes: Optional(String()),
});
